import React from 'react';
import '../styles/teamCall.css';
import { Link } from 'react-router-dom';

const TeamCall = () => {
  return (
    <section className="team-call-section bg-gradient-snow">
      <div className="team-call-overlay"></div>
      <div className="team-call-container">
        <div className="team-call-content">
          <div className="team-call-header">
            <h2>Join the Team That Grows With the Seasons</h2>
            <div className="team-call-subtitle">
              <span className="highlight-badge">35 Years Strong</span>
              <span className="highlight-badge">60+ Team Members</span>
              <span className="highlight-badge">Sun Valley's Premier</span>
              <span className="highlight-badge red">Career Opportunities</span>
            </div>
          </div>
          
          <div className="team-call-body">
            <div className="company-story">
              <p className="lead-text">
                All Seasons has been a fixture in the Valley for the past 35 years. Our passion for quality work and integrity have grown All Seasons Landscaping into the large and capable firm we are today.
              </p>
              
              <div className="team-call-services-grid">
                <div className="team-call-service-item" data-number="01">
                  <div className="team-call-service-icon">DESIGN</div>
                  <span>Superior Design & Installation</span>
                </div>
                <div className="team-call-service-item" data-number="02">
                  <div className="team-call-service-icon">RESIDENTIAL</div>
                  <span>High-End Residential Remodels</span>
                </div>
                <div className="team-call-service-item" data-number="03">
                  <div className="team-call-service-icon">COMMERCIAL</div>
                  <span>Commercial Installations</span>
                </div>
                <div className="team-call-service-item" data-number="04">
                  <div className="team-call-service-icon">YEAR-ROUND</div>
                  <span>Year-Round Maintenance</span>
                </div>
              </div>
            </div>
            
            <div className="culture-highlight">
              <div className="culture-card">
                <h3>Our People, Our Pride</h3>
                <p>
                  We take pride in our people. Many of our team members have been with us for 15–20 years, 
                  a testament to our strong culture and family-like atmosphere. With more than 60 team members 
                  in high season, we're one of the largest landscape firms in the area.
                </p>
                {/* <div className="culture-stats">
                  <div className="stat">
                    <span className="stat-number">15-20</span>
                    <span className="stat-label">Years Average Tenure</span>
                  </div>
                  <div className="stat">
                    <span className="stat-number">60+</span>
                    <span className="stat-label">Peak Season Team</span>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
          
          {/* <div className="team-call-footer">
            <p className="expertise-text">
              Our management team brings deep technical expertise and a shared commitment to delivering beautiful, honest work.
            </p>
            <div className="team-call-cta-buttons">
              <Link to="/TeamPage#positions" className="team-call-cta-button red">
                <span>Job Opportunities</span>
                <span className="team-call-button-arrow">→</span>
              </Link>
              <Link to="/ApplyHere" className="team-call-cta-button primary">
                <span>Apply Now</span>
                <span className="team-call-button-arrow">→</span>
              </Link>
              <a href="/TeamPage" className="team-call-cta-button secondary">
                <span>Meet Our Team</span>
                <span className="team-call-button-arrow"></span>
              </a>
            </div>
          </div> */}
        </div>
      </div>
    </section>
  );
};

export default TeamCall;